import React from "react";
import LoginView from "../components/Home/LoginView";
function Home(){
    return(
        <section>
            <LoginView />
        </section>
    );
}
export default Home;